import { CIDService } from "src/app/services/common/cid.service";
import { Validators, FormGroupDirective } from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { TranslateService } from "@ngstack/translate";
import { FormControl, FormGroup } from "@angular/forms";
import { Component, OnInit, ViewChild, Inject } from "@angular/core";

import { IBranch } from "src/app/interfaces/branch";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IConfirm } from "src/app/interfaces/confirm";
import { ErrorsService } from "src/app/services/common/errors.service";
import { IPlacementType } from "./../../../../interfaces/placementType";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { IEducationPackage } from "./../../../../interfaces/educationPackage";
import { MatTableDataSource, MatPaginator, MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { PlacementTypeService } from "src/app/services/http/business/placement/placement-type.service";
import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { BIDService } from "src/app/services/common/bid.service";
import { HttpHeaders } from "@angular/common/http";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-placement-type-entry",
  templateUrl: "./placement-type-entry.component.html",
  styleUrls: ["./placement-type-entry.component.css"]
})
export class PlacementTypeEntryComponent implements OnInit {
  form: FormGroup;
  BranchEncryptId: string;
  companyList: ICompany[];
  branchList: IBranch[];
  showList: boolean = true;
  addPlacementType: boolean = true;
  eduPackageList: IEducationPackage;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  isOwner: boolean;
  dataSource = new MatTableDataSource<IPlacementType>();

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private bidService: BIDService,
    private cidService: CIDService,
    private snackbar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private branchService: BranchService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private eduPackageService: EducationPackageService,
    private placementTypeService: PlacementTypeService,
    public dialogRef: MatDialogRef<PlacementTypeEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IEducationPackage
  ) {
    console.log(this.data);

  }

  displayedColumns: string[] = [
    //  this.translate.get('label.branch'),
    this.translate.get("label.title"),
    this.translate.get("label.price"),
    this.translate.get("label.timeDuration"),
    this.translate.get("label.ValidityPeriod"),
    this.translate.get("label.PercentageTeacher"),
    "function"
  ];
  //@ViewChild(FormGroupDirective) formDirective;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    console.log(this.data);
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
    this.cteateForm();
    this.loadEduPackageList();
    this.dataSource.paginator = this.paginator;
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  setCompanyCode(e: string) {
    this.cidService.setCID(e);
    this.dataSource = null;
    this.paginator.length = 0;
    this.getBranches(e);
  }

  getBranches(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );

    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.branchList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadPlacementList(event: string) {
    this.BranchEncryptId = event;
    if (this.isOwner)
      this.bidService.setBID(event);

    this.placementTypeService.listWithDeactive(this.data.Id, 0, 0).subscribe(
      res => {
        this.showList = false;
        this.dataSource = res.DataList;
        this.paginator.length = res.Total;
        this.paginator.pageIndex = 0;
        this.paginator.pageSize = 10;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }
  paginatorEvent(event) {
    this.placementTypeService
      .list(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  loadEduPackageList() {
    this.eduPackageService.getList().subscribe(
      res => {
        this.eduPackageList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  cteateForm() {
    this.form = this.fb.group({
      PackageId: [this.data.Id, Validators.compose([Validators.required])],
      Title: [
        null,
        Validators.compose([Validators.required, Validators.maxLength(50)])
      ],
      Price: [
        null,
        Validators.compose([Validators.required, Validators.min(0)])
      ],
      ValidityPeriod: [
        null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(240)
        ])
      ],
      Duration: [
        null,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(240)
        ])
      ],
      PercentageTeacher: [
        null,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(100)
        ])
      ],
      BranchDataList: this.fb.array([
        new FormGroup({
          BranchEncryptId: new FormControl("", Validators.required)
        })
      ])
    });
  }

  submit(form: any, formDirective: FormGroupDirective) {
    this.errors = new Array();
    var listofObj = form.BranchDataList[0].BranchEncryptId;
    var arrList = new Array();
    for (let x = 0; x <= listofObj.length - 1; x++) {
      arrList.push({
        BranchEncryptId: listofObj[x]
      });
    }
    form.BranchDataList = arrList;
    if (form.BranchDataList[0].BranchEncryptId == null) {
      form.BranchDataList = null;
    }
    this.placementTypeService.add(form).subscribe(
      () => {

        this.addPlacementType = true;
        this.form.reset();
        formDirective.resetForm();
        this.cteateForm();
        this.loadPlacementList(this.BranchEncryptId);
        this.snackbar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  add() {
    this.addPlacementType = false;
  }

  cancel() {
    this.addPlacementType = true;
  }

  delete(data: IPlacementType) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: data.Title
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    this.dialog
      .open(ConfirmComponent, {
        width: "250px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {

          this.placementTypeService.delete({ Id: data.Id }).subscribe(
            () => {

              this.snackbar.OpenSnackBar(
                'حذف نوع تعیین سطح از شعبه با موفقیت انجام شد',
                "ok",
                5000,
                SoundEnum.beep
              );

              this.loadPlacementList(this.BranchEncryptId);

            },
            err => {
              this.errorService.recordHasBennUsed(err);
            }
          );

        }
      });


  }

  activeDeactive(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: data.IsActive ? this.translate.get("confirm.inActive", {
        name: data.Title
      }) : this.translate.get("confirm.active", {
        name: data.Title
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    this.dialog
      .open(ConfirmComponent, {
        width: "250px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {

          this.placementTypeService.activeDeactive({ Id: data.Id }).subscribe(
            () => {
              this.snackbar.OpenSnackBar(
                'نوع تعیین سطح با موفقیت غیر فعال گردید',
                "ok",
                5000,
                SoundEnum.beep
              );

              this.loadPlacementList(this.BranchEncryptId);

            },
            err => {
              this.errorService.recordHasBennUsed(err);
            }
          );

        }
      });


  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
